// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.other-table {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  gap: 1rem;
}
.other-table__upper {
  display: flex;
  flex-direction: row-reverse;
  justify-content: space-between;
  align-items: center;
  padding: 0.5rem 0;
}
.other-table__upper__controls {
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 0.75rem;
  flex-wrap: nowrap;
}
.other-table__upper__controls__add-button {
  min-width: 140px;
  height: 40px;
  background-color: #4F4BFF;
  color: white;
  border-color: #DEDEDE;
  border-radius: 6px;
  font-size: 0.85rem;
  white-space: nowrap;
  padding: 0 1rem;
}
.other-table__upper__controls__save-button {
  min-width: 140px;
  height: 40px;
  background-color: #4F4BFF;
  color: white;
  border-color: #DEDEDE;
  border-radius: 6px;
  font-size: 0.85rem;
  white-space: nowrap;
  padding: 0 1rem;
}
.other-table__upper__controls__filter-button {
  min-width: fit-content;
  height: 40px;
  background-color: transparent;
  color: black;
  border-color: #DEDEDE;
  border-radius: 6px;
  font-size: 0.85rem;
  white-space: nowrap;
  padding: 0 1rem;
}
.other-table__upper__controls__filter-button.filters-active {
  background-color: #4F4BFF;
  color: white;
}
.other-table__upper__controls .p-inputgroup {
  min-width: 200px;
  position: relative;
}
.other-table__upper__controls .p-inputgroup .p-inputgroup-addon {
  position: absolute;
  left: 0.75rem;
  top: 50%;
  transform: translateY(-50%);
  z-index: 1;
  background: none;
  border: none;
  color: #64748B;
}
.other-table__upper__controls .p-inputgroup .p-inputtext {
  padding-left: 2.5rem;
  width: 100%;
  height: 40px;
}
.other-table__table {
  height: 55vh;
  overflow-y: auto;
  display: flex;
  flex-direction: column;
}
.other-table__table__header {
  padding: 10px 1rem;
  display: grid;
  grid-template-columns: 5% 20% 20% 20% 20% 15%;
  place-items: center;
  background-color: #F9FAFB;
  border-radius: 7px;
  height: 8%;
  font-size: 0.85rem;
}
.other-table__table__header .sortable-header {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  cursor: pointer;
  -webkit-user-select: none;
          user-select: none;
  position: relative;
}
.other-table__table__header .sortable-header:hover {
  color: #4F4BFF;
}
.other-table__table__header .sortable-header:hover:not(:has(.pi))::after {
  content: "\\e930";
  font-family: "primeicons";
  font-size: 0.75rem;
  opacity: 0.5;
  margin-left: 0.5rem;
}
.other-table__table__header .sortable-header .pi {
  font-size: 0.75rem;
}
.other-table__table__header div:nth-child(2) {
  justify-self: start;
  padding-left: 1rem;
}
.other-table__table__header div:nth-child(2).sortable-header {
  display: flex;
  align-items: center;
}
.other-table__table__body {
  flex: 1 1;
  display: flex;
  flex-direction: column;
}
.other-table__table__row--empty {
  height: 60px;
}
.other-table__table__mobile-item__cells__column__header {
  background-color: #F8F9FA;
  padding: 0.5rem;
  border-radius: 4px;
  width: 100%;
  text-align: center;
  color: #64748B;
  font-weight: 500;
}
.other-table__lower-controls {
  height: fit-content;
  display: flex;
  flex-direction: row;
  justify-content: end;
  align-items: center;
}
.other-table__lower-controls__rows-per-page, .other-table__lower-controls__visible-rows {
  font-size: 0.85rem;
  color: #64748B;
  margin-right: 75px;
}
.other-table__lower-controls__button {
  width: 110px;
  height: 40px;
  background-color: transparent;
  color: #726BEA;
  border-color: #DEDEDE;
  border-radius: 6px;
  font-size: 0.85rem;
  margin-right: 10px;
}
.other-table__lower-controls .disabled {
  color: #DEDEDE;
  pointer-events: none;
}
.other-table__filter-container {
  position: relative;
}
.other-table__filter-container .filters-active {
  background-color: #4F4BFF;
  color: white;
}
.other-table__filter-container .filters-active:hover {
  background-color: #3f3ccc;
}
.other-table__filter-backdrop {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.5);
  z-index: 998;
  display: none;
}
.other-table__filter-backdrop.visible {
  display: block;
}
.other-table__filters-popup {
  position: absolute;
  top: calc(100% + 8px);
  right: 0;
  background: white;
  border: 1px solid #ECECEC;
  border-radius: 8px;
  padding: 1.25rem;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);
  z-index: 999;
  min-width: 250px;
  max-height: 400px;
  overflow-y: auto;
}
.other-table__filters-popup__item {
  display: flex;
  align-items: center;
  gap: 0.75rem;
  padding: 0.75rem;
  cursor: pointer;
  border-radius: 6px;
}
.other-table__filters-popup__item label {
  cursor: pointer;
  margin-left: 0.25rem;
  color: #1E293B;
  font-size: 0.9rem;
}
.other-table__filters-popup__item:hover {
  background: #F8F9FA;
}
.other-table__filters-popup::-webkit-scrollbar {
  width: 8px;
}
.other-table__filters-popup::-webkit-scrollbar-track {
  background: #F8F9FA;
  border-radius: 4px;
}
.other-table__filters-popup::-webkit-scrollbar-thumb {
  background: #E2E8F0;
  border-radius: 4px;
}
.other-table__filters-popup::-webkit-scrollbar-thumb:hover {
  background: #CBD5E1;
}

.p-checkbox.p-highlight .p-checkbox-box {
  background-color: #4F4BFF;
}

@media screen and (max-width: 768px) {
  .other-table {
    height: calc(100vh - 200px);
    overflow-y: auto;
  }
  .other-table__upper {
    position: sticky;
    top: calc(var(--header-height, 100px));
    background-color: white;
    z-index: 10;
    padding-bottom: 1.1rem;
    border-bottom: 1px solid #ECECEC;
  }
  .other-table__upper__controls {
    width: 100%;
    justify-content: flex-end;
  }
  .other-table__upper__controls .p-inputgroup {
    flex: 1 1;
    margin-right: 0.5rem;
  }
  .other-table__upper__controls__filter-button, .other-table__upper__controls__save-button {
    min-width: 40px;
    width: 40px;
    padding: 0;
  }
  .other-table__upper__controls__filter-button .p-button-label, .other-table__upper__controls__save-button .p-button-label {
    display: none;
  }
  .other-table__upper__controls__filter-button .pi, .other-table__upper__controls__save-button .pi {
    font-size: 1.25rem;
  }
  .other-table__upper__controls__add-button {
    display: none;
  }
  .other-table__upper__controls .p-inputtext {
    height: 40px;
    font-size: 0.9rem;
    padding: 0.75rem;
  }
  .other-table__table {
    height: auto;
    overflow: visible;
  }
  .other-table__table__header {
    display: none;
  }
  .other-table__table__mobile-item {
    display: flex;
    padding: 1.25rem 1rem;
    border-bottom: 1px solid #ECECEC;
  }
  .other-table__table__mobile-item__info {
    width: 20%;
    padding-right: 0.5rem;
  }
  .other-table__table__mobile-item__info__name {
    font-weight: 500;
    margin-bottom: 0.5rem;
    font-size: 1rem;
  }
  .other-table__table__mobile-item__info__total {
    color: #64748B;
    font-size: 0.9rem;
  }
  .other-table__table__mobile-item__cells {
    width: 80%;
    display: flex;
    flex-direction: column;
    gap: 1.25rem;
  }
  .other-table__table__mobile-item__cells__column {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 0.75rem;
    padding: 0.75rem 0;
    border-bottom: 1px solid #f5f5f5;
  }
  .other-table__table__mobile-item__cells__column:last-child {
    border-bottom: none;
  }
  .other-table__table__mobile-item__cells__column__header {
    font-size: 1.1rem;
    color: #64748B;
    font-weight: 600;
  }
  .other-table__lower-controls {
    display: none;
  }
  .other-table__filters-popup {
    position: fixed;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    width: 90%;
    max-width: 400px;
    max-height: 80vh;
  }
  .other-table__filter-backdrop {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(0, 0, 0, 0.5);
    z-index: 9998;
  }
}`, "",{"version":3,"sources":["webpack://./src/features/profile/components/other-table/other-table.scss"],"names":[],"mappings":"AAAA;EACI,WAAA;EACA,YAAA;EACA,aAAA;EACA,sBAAA;EACA,SAAA;AACJ;AAAI;EACI,aAAA;EACA,2BAAA;EACA,8BAAA;EACA,mBAAA;EACA,iBAAA;AAER;AADQ;EACI,aAAA;EACA,mBAAA;EACA,mBAAA;EACA,YAAA;EACA,iBAAA;AAGZ;AAFY;EACI,gBAAA;EACA,YAAA;EACA,yBAAA;EACA,YAAA;EACA,qBAAA;EACA,kBAAA;EACA,kBAAA;EACA,mBAAA;EACA,eAAA;AAIhB;AAFY;EACI,gBAAA;EACA,YAAA;EACA,yBAAA;EACA,YAAA;EACA,qBAAA;EACA,kBAAA;EACA,kBAAA;EACA,mBAAA;EACA,eAAA;AAIhB;AAFY;EACI,sBAAA;EACA,YAAA;EACA,6BAAA;EACA,YAAA;EACA,qBAAA;EACA,kBAAA;EACA,kBAAA;EACA,mBAAA;EACA,eAAA;AAIhB;AAHgB;EACI,yBAAA;EACA,YAAA;AAKpB;AADY;EACI,gBAAA;EACA,kBAAA;AAGhB;AADgB;EACI,kBAAA;EACA,aAAA;EACA,QAAA;EACA,2BAAA;EACA,UAAA;EACA,gBAAA;EACA,YAAA;EACA,cAAA;AAGpB;AAAgB;EACI,oBAAA;EACA,WAAA;EACA,YAAA;AAEpB;AAGI;EACI,YAAA;EACA,gBAAA;EACA,aAAA;EACA,sBAAA;AADR;AAEQ;EACI,kBAAA;EACA,aAAA;EACA,6CAAA;EACA,mBAAA;EACA,yBAAA;EACA,kBAAA;EACA,UAAA;EACA,kBAAA;AAAZ;AACY;EACI,aAAA;EACA,mBAAA;EACA,WAAA;EACA,eAAA;EACA,yBAAA;UAAA,iBAAA;EACA,kBAAA;AAChB;AACgB;EACI,cAAA;AACpB;AAEwB;EACI,gBAAA;EACA,yBAAA;EACA,kBAAA;EACA,YAAA;EACA,mBAAA;AAA5B;AAKgB;EACI,kBAAA;AAHpB;AAOY;EACI,mBAAA;EACA,kBAAA;AALhB;AAOgB;EACI,aAAA;EACA,mBAAA;AALpB;AASQ;EACI,SAAA;EACA,aAAA;EACA,sBAAA;AAPZ;AASQ;EACI,YAAA;AAPZ;AAYoB;EACI,yBAAA;EACA,eAAA;EACA,kBAAA;EACA,WAAA;EACA,kBAAA;EACA,cAAA;EACA,gBAAA;AAVxB;AAgBI;EACI,mBAAA;EACA,aAAA;EACA,mBAAA;EACA,oBAAA;EACA,mBAAA;AAdR;AAgBQ;EAEI,kBAAA;EACA,cAAA;EACA,kBAAA;AAfZ;AAkBQ;EACI,YAAA;EACA,YAAA;EACA,6BAAA;EACA,cAAA;EACA,qBAAA;EACA,kBAAA;EACA,kBAAA;EACA,kBAAA;AAhBZ;AAkBQ;EACI,cAAA;EACA,oBAAA;AAhBZ;AAmBI;EACI,kBAAA;AAjBR;AAmBQ;EACI,yBAAA;EACA,YAAA;AAjBZ;AAmBY;EACI,yBAAA;AAjBhB;AAsBI;EACI,eAAA;EACA,MAAA;EACA,OAAA;EACA,QAAA;EACA,SAAA;EACA,8BAAA;EACA,YAAA;EACA,aAAA;AApBR;AAsBQ;EACI,cAAA;AApBZ;AAwBI;EACI,kBAAA;EACA,qBAAA;EACA,QAAA;EACA,iBAAA;EACA,yBAAA;EACA,kBAAA;EACA,gBAAA;EACA,0CAAA;EACA,YAAA;EACA,gBAAA;EACA,iBAAA;EACA,gBAAA;AAtBR;AAwBQ;EACI,aAAA;EACA,mBAAA;EACA,YAAA;EACA,gBAAA;EACA,eAAA;EACA,kBAAA;AAtBZ;AAwBY;EACI,eAAA;EACA,oBAAA;EACA,cAAA;EACA,iBAAA;AAtBhB;AAyBY;EACI,mBAAA;AAvBhB;AA2BQ;EACI,UAAA;AAzBZ;AA4BQ;EACI,mBAAA;EACA,kBAAA;AA1BZ;AA6BQ;EACI,mBAAA;EACA,kBAAA;AA3BZ;AA6BY;EACI,mBAAA;AA3BhB;;AAiCA;EACI,yBAAA;AA9BJ;;AAiCA;EACE;IACE,2BAAA;IACA,gBAAA;EA9BF;EAgCE;IACE,gBAAA;IACA,sCAAA;IACA,uBAAA;IACA,WAAA;IACA,sBAAA;IACA,gCAAA;EA9BJ;EAgCI;IACE,WAAA;IACA,yBAAA;EA9BN;EAgCM;IACE,SAAA;IACA,oBAAA;EA9BR;EAiCM;IAEE,eAAA;IACA,WAAA;IACA,UAAA;EAhCR;EAkCQ;IACE,aAAA;EAhCV;EAmCQ;IACE,kBAAA;EAjCV;EAoCM;IACE,aAAA;EAlCR;EAqCM;IACE,YAAA;IACA,iBAAA;IACA,gBAAA;EAnCR;EAwCE;IACE,YAAA;IACA,iBAAA;EAtCJ;EAwCI;IACE,aAAA;EAtCN;EAyCI;IACE,aAAA;IACA,qBAAA;IACA,gCAAA;EAvCN;EAyCM;IACE,UAAA;IACA,qBAAA;EAvCR;EAyCQ;IACE,gBAAA;IACA,qBAAA;IACA,eAAA;EAvCV;EA0CQ;IACE,cAAA;IACA,iBAAA;EAxCV;EA4CM;IACE,UAAA;IACA,aAAA;IACA,sBAAA;IACA,YAAA;EA1CR;EA4CQ;IACE,aAAA;IACA,sBAAA;IACA,mBAAA;IACA,YAAA;IACA,kBAAA;IACA,gCAAA;EA1CV;EA4CU;IACE,mBAAA;EA1CZ;EA6CU;IACE,iBAAA;IACA,cAAA;IACA,gBAAA;EA3CZ;EAkDE;IACE,aAAA;EAhDJ;EAmDE;IACE,eAAA;IACA,QAAA;IACA,SAAA;IACA,gCAAA;IACA,UAAA;IACA,gBAAA;IACA,gBAAA;EAjDJ;EAoDE;IACE,eAAA;IACA,MAAA;IACA,OAAA;IACA,QAAA;IACA,SAAA;IACA,8BAAA;IACA,aAAA;EAlDJ;AACF","sourcesContent":[".other-table{\n    width: 100%;\n    height: 100%;\n    display: flex;\n    flex-direction: column;\n    gap: 1rem;\n    &__upper{\n        display: flex;\n        flex-direction: row-reverse;\n        justify-content: space-between;\n        align-items: center;\n        padding: 0.5rem 0;\n        &__controls{\n            display: flex;\n            flex-direction: row;\n            align-items: center;\n            gap: 0.75rem;\n            flex-wrap: nowrap;\n            &__add-button{\n                min-width: 140px;\n                height: 40px;\n                background-color:#4F4BFF;\n                color: white;\n                border-color: #DEDEDE;\n                border-radius: 6px;\n                font-size: 0.85rem;\n                white-space: nowrap;\n                padding: 0 1rem;\n            }\n            &__save-button{\n                min-width: 140px;\n                height: 40px;\n                background-color:#4F4BFF;\n                color: white;\n                border-color: #DEDEDE;\n                border-radius: 6px;\n                font-size: 0.85rem;\n                white-space: nowrap;\n                padding: 0 1rem;\n            }\n            &__filter-button{\n                min-width: fit-content;\n                height: 40px;\n                background-color:transparent;\n                color: black;\n                border-color: #DEDEDE;\n                border-radius: 6px;\n                font-size: 0.85rem;\n                white-space: nowrap;\n                padding: 0 1rem;\n                &.filters-active {\n                    background-color: #4F4BFF;\n                    color: white;\n                }\n            }\n\n            .p-inputgroup {\n                min-width: 200px;\n                position: relative;\n                \n                .p-inputgroup-addon {\n                    position: absolute;\n                    left: 0.75rem;\n                    top: 50%;\n                    transform: translateY(-50%);\n                    z-index: 1;\n                    background: none;\n                    border: none;\n                    color: #64748B;\n                }\n                \n                .p-inputtext {\n                    padding-left: 2.5rem;\n                    width: 100%;\n                    height: 40px;\n                }\n            }\n        }\n    }\n    &__table{\n        height: 55vh;\n        overflow-y: auto;\n        display: flex;\n        flex-direction: column;\n        &__header{\n            padding: 10px 1rem;\n            display: grid;\n            grid-template-columns: 5% 20% 20% 20% 20% 15% ;\n            place-items: center;\n            background-color: #F9FAFB;\n            border-radius: 7px;\n            height: 8%;\n            font-size: 0.85rem;\n            .sortable-header {\n                display: flex;\n                align-items: center;\n                gap: 0.5rem;\n                cursor: pointer;\n                user-select: none;\n                position: relative;\n                \n                &:hover {\n                    color: #4F4BFF;\n\n                    &:not(:has(.pi)) {\n                        &::after {\n                            content: '\\e930';\n                            font-family: 'primeicons';\n                            font-size: 0.75rem;\n                            opacity: 0.5;\n                            margin-left: 0.5rem;\n                        }\n                    }\n                }\n\n                .pi {\n                    font-size: 0.75rem;\n                }\n            }\n\n            div:nth-child(2) {  // PRODUCTS column\n                justify-self: start;\n                padding-left: 1rem;\n                \n                &.sortable-header {\n                    display: flex;\n                    align-items: center;\n                }\n            }\n        }\n        &__body {\n            flex: 1;\n            display: flex;\n            flex-direction: column;\n        }\n        &__row--empty {\n            height: 60px;\n        }\n        &__mobile-item {\n            &__cells {\n                &__column {\n                    &__header {\n                        background-color: #F8F9FA;\n                        padding: 0.5rem;\n                        border-radius: 4px;\n                        width: 100%;\n                        text-align: center;\n                        color: #64748B;\n                        font-weight: 500;\n                    }\n                }\n            }\n        }\n    }\n    &__lower-controls{\n        height: fit-content;\n        display: flex;\n        flex-direction: row;\n        justify-content: end;\n        align-items: center;\n\n        &__rows-per-page,\n        &__visible-rows{\n            font-size: 0.85rem;\n            color: #64748B;\n            margin-right: 75px;\n        }\n        \n        &__button{\n            width: 110px;\n            height: 40px;\n            background-color:transparent;\n            color: #726BEA;\n            border-color: #DEDEDE;\n            border-radius: 6px;\n            font-size: 0.85rem;\n            margin-right: 10px;\n        }\n        .disabled{\n            color: #DEDEDE;\n            pointer-events: none;\n        }\n    }\n    &__filter-container {\n        position: relative;\n        \n        .filters-active {\n            background-color: #4F4BFF;\n            color: white;\n            \n            &:hover {\n                background-color: #3f3ccc;\n            }\n        }\n    }\n\n    &__filter-backdrop {\n        position: fixed;\n        top: 0;\n        left: 0;\n        right: 0;\n        bottom: 0;\n        background: rgba(0, 0, 0, 0.5);\n        z-index: 998;\n        display: none;\n\n        &.visible {\n            display: block;\n        }\n    }\n\n    &__filters-popup {\n        position: absolute;\n        top: calc(100% + 8px);\n        right: 0;\n        background: white;\n        border: 1px solid #ECECEC;\n        border-radius: 8px;\n        padding: 1.25rem;\n        box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);\n        z-index: 999;\n        min-width: 250px;\n        max-height: 400px;\n        overflow-y: auto;\n\n        &__item {\n            display: flex;\n            align-items: center;\n            gap: 0.75rem;\n            padding: 0.75rem;\n            cursor: pointer;\n            border-radius: 6px;\n\n            label {\n                cursor: pointer;\n                margin-left: 0.25rem;\n                color: #1E293B;\n                font-size: 0.9rem;\n            }\n\n            &:hover {\n                background: #F8F9FA;\n            }\n        }\n\n        &::-webkit-scrollbar {\n            width: 8px;\n        }\n\n        &::-webkit-scrollbar-track {\n            background: #F8F9FA;\n            border-radius: 4px;\n        }\n\n        &::-webkit-scrollbar-thumb {\n            background: #E2E8F0;\n            border-radius: 4px;\n            \n            &:hover {\n                background: #CBD5E1;\n            }\n        }\n    }\n}\n\n.p-checkbox.p-highlight .p-checkbox-box{\n    background-color: #4F4BFF ;\n}\n\n@media screen and (max-width: 768px) {\n  .other-table {\n    height: calc(100vh - 200px);\n    overflow-y: auto;\n    \n    &__upper {\n      position: sticky;\n      top: calc(var(--header-height, 100px));\n      background-color: white;\n      z-index: 10;\n      padding-bottom: 1.1rem;\n      border-bottom: 1px solid #ECECEC;\n      \n      &__controls {\n        width: 100%;\n        justify-content: flex-end;\n        \n        .p-inputgroup {\n          flex: 1;\n          margin-right: 0.5rem;\n        }\n        \n        &__filter-button,\n        &__save-button {\n          min-width: 40px;\n          width: 40px;\n          padding: 0;\n          \n          .p-button-label {\n            display: none;\n          }\n          \n          .pi {\n            font-size: 1.25rem;\n          }\n        }\n        &__add-button {\n          display: none;\n        }\n        \n        .p-inputtext {\n          height: 40px;\n          font-size: 0.9rem;\n          padding: 0.75rem;\n        }\n      }\n    }\n\n    &__table {\n      height: auto;\n      overflow: visible;\n      \n      &__header {\n        display: none;\n      }\n      \n      &__mobile-item {\n        display: flex;\n        padding: 1.25rem 1rem;\n        border-bottom: 1px solid #ECECEC;\n        \n        &__info {\n          width: 20%;\n          padding-right: 0.5rem;\n          \n          &__name {\n            font-weight: 500;\n            margin-bottom: 0.5rem;\n            font-size: 1rem;\n          }\n          \n          &__total {\n            color: #64748B;\n            font-size: 0.9rem;\n          }\n        }\n        \n        &__cells {\n          width: 80%;\n          display: flex;\n          flex-direction: column;\n          gap: 1.25rem;\n          \n          &__column {\n            display: flex;\n            flex-direction: column;\n            align-items: center;\n            gap: 0.75rem;\n            padding: 0.75rem 0;\n            border-bottom: 1px solid #f5f5f5;\n            \n            &:last-child {\n              border-bottom: none;\n            }\n            \n            &__header {\n              font-size: 1.1rem;\n              color: #64748B;\n              font-weight: 600;\n            }\n          }\n        }\n      }\n    }\n    \n    &__lower-controls {\n      display: none;\n    }\n\n    &__filters-popup {\n      position: fixed;\n      top: 50%;\n      left: 50%;\n      transform: translate(-50%, -50%);\n      width: 90%;\n      max-width: 400px;\n      max-height: 80vh;\n    }\n\n    &__filter-backdrop {\n      position: fixed;\n      top: 0;\n      left: 0;\n      right: 0;\n      bottom: 0;\n      background: rgba(0, 0, 0, 0.5);\n      z-index: 9998;\n    }\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
